// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jaFP","field":"styles_field__24BMv","fieldCol":"styles_fieldCol__1uXSi","diffCol":"styles_diffCol__GCaJu","diff":"styles_diff__3cWHF"};